import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
} from '@mediwareinc/wellsky-dls-react';

const TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LINK: 'link',
  TERTIARY: 'tertiary',
};

export const Button = ({
  type = TYPE.PRIMARY,
  disabled,
  loading,
  htmlType,
  ...restProps
}) => {
  let ButtonComponent = PrimaryButton;

  switch (type) {
    case TYPE.SECONDARY: {
      ButtonComponent = SecondaryButton;
      break;
    }

    case TYPE.LINK: {
      ButtonComponent = TertiaryButton;
      break;
    }

    case TYPE.TERTIARY: {
      ButtonComponent = LinkButton;
      break;
    }
  }

  return (
    <ButtonComponent
      isDisabled={disabled}
      isLoading={loading}
      type={htmlType}
      {...restProps}
    />
  );
};
